"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const PreferencesContext_1 = require("../../context/PreferencesContext");
const useNucleus_1 = __importDefault(require("../../hooks/useNucleus"));
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const getUniqueNuclei_1 = require("../../utility/getUniqueNuclei");
const NucleusPreferences_1 = require("../extra/preferences/NucleusPreferences");
const PreferencesContainer_1 = require("../extra/preferences/PreferencesContainer");
const formatFields = [
    {
        id: 1,
        label: 'Serial number :',
        checkControllerName: 'showSerialNumber',
        hideFormatField: true,
    },
    {
        id: 2,
        label: 'δ (ppm) :',
        checkControllerName: 'deltaPPM.show',
        formatControllerName: 'deltaPPM.format',
    },
    {
        id: 3,
        label: 'δ (Hz) :',
        checkControllerName: 'deltaHz.show',
        formatControllerName: 'deltaHz.format',
    },
    {
        id: 4,
        label: 'Peak Width (Hz)',
        checkControllerName: 'peakWidth.show',
        formatControllerName: 'peakWidth.format',
    },
    {
        id: 5,
        label: 'Intensity :',
        checkControllerName: 'intensity.show',
        formatControllerName: 'intensity.format',
    },
    {
        id: 6,
        label: 'kind :',
        checkControllerName: 'fwhm.show',
    },
    {
        id: 7,
        label: 'fwhm :',
        checkControllerName: 'fwhm.show',
        formatControllerName: 'fwhm.format',
    },
    {
        id: 8,
        label: 'mu :',
        checkControllerName: 'mu.show',
        formatControllerName: 'mu.format',
    },
    {
        id: 9,
        label: 'Delete action :',
        checkControllerName: 'showDeleteAction',
        hideFormatField: true,
    },
    {
        id: 10,
        label: 'Edit peak shape action :',
        checkControllerName: 'showEditPeakShapeAction',
        hideFormatField: true,
    },
];
function PeaksPreferences(props, ref) {
    const formRef = (0, react_1.useRef)(null);
    const preferences = (0, PreferencesContext_1.usePreferences)();
    const nucleus = (0, useNucleus_1.default)();
    const nuclei = (0, react_1.useMemo)(() => (0, getUniqueNuclei_1.getUniqueNuclei)(nucleus), [nucleus]);
    const preferencesByNuclei = (0, usePanelPreferences_1.usePanelPreferencesByNuclei)('peaks', nuclei);
    const saveHandler = (0, react_1.useCallback)((values) => {
        preferences.dispatch({
            type: 'SET_PANELS_PREFERENCES',
            payload: { key: 'peaks', value: values },
        });
    }, [preferences]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        saveSetting: () => {
            formRef.current.submitForm();
        },
    }), []);
    return ((0, jsx_runtime_1.jsx)(PreferencesContainer_1.PreferencesContainer, { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: preferencesByNuclei, onSubmit: saveHandler, innerRef: formRef, children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: nuclei?.map((n) => ((0, jsx_runtime_1.jsx)(NucleusPreferences_1.NucleusPreferences, { nucleus: n, fields: formatFields }, n))) }) }) }));
}
exports.default = (0, react_1.memo)((0, react_1.forwardRef)(PeaksPreferences));
